import { Box, Heading, getVariant } from '@apia/theme';
import { ReactNode, useState } from 'react';
import { IconButton } from '../../forms';

export const ContainerWithHeader = ({
  title,
  children,
  footerChildren,
  onClose,
  additionalButtons,
}: {
  title: string;
  children: ReactNode;
  footerChildren?: ReactNode;
  additionalButtons?: ReactNode;
  onClose?: () => void;
}) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleExpandClick = () => {
    setIsFullScreen((prev) => !prev);
  };
  return (
    <Box
      className={`container  ${isFullScreen ? 'fullScreen' : ''}`}
      {...getVariant('layout.common.components.containers.containerWithHeader')}
    >
      <Box className="container__header">
        <Heading as="h2">{title}</Heading>
        <Box className="container__rightButtons">
          {additionalButtons}
          <IconButton
            className="container__rightButtons__maximizedBtn"
            variant="outline"
            icon={isFullScreen ? 'Minimize' : 'Maximize'}
            onClick={() => handleExpandClick()}
          />
          {onClose && (
            <IconButton
              variant="outline-danger"
              icon="Close"
              onClick={() => onClose()}
            />
          )}
        </Box>
      </Box>
      <Box className="container__content">{children}</Box>
      {footerChildren && (
        <Box className="container__footer">{footerChildren}</Box>
      )}
    </Box>
  );
};
